import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { Section, Field } from "@/components/common";

const NOTE = "To change your account details, please submit a support request.";
export const ACCOUNT_REQUEST_URL = "/app/tickets?new=account_change";

function Note({ testId }) {
  return <Link to={ACCOUNT_REQUEST_URL} className="mt-1 block text-xs text-[#2B7F77] underline" data-testid={testId}>{NOTE}</Link>;
}

/** Read-only account details: email and name are changed by PressOps support only. */
export function AccountDetails() {
  const { user } = useAuth();
  return (
    <Section title="Your account" testId="account-details">
      <div className="grid gap-3 p-5 sm:grid-cols-2">
        <Field label="Email (sign-in)"><Input readOnly value={user.email} className="bg-slate-50 text-slate-700" data-testid="account-email-readonly" /><Note testId="account-email-note" /></Field>
        <Field label="Display name"><Input readOnly value={user.name} className="bg-slate-50 text-slate-700" data-testid="account-name-readonly" /><Note testId="account-name-note" /></Field>
      </div>
    </Section>
  );
}
